import {Component, input, model, signal} from '@angular/core';
import {Helpers} from '@selpia/shared/utils';
import {FormsModule} from '@angular/forms';
import {ToggleSwitchModule} from 'primeng/toggleswitch';

@Component({
  selector: 'lib-switch-input',
  imports: [ToggleSwitchModule, FormsModule],
  templateUrl: './switch-input.component.html',
  styleUrl: './switch-input.component.scss',
})
export class SwitchInputComponent<T> {
  readonly model = model.required<T>();
  readonly label = input<string | undefined>();

  protected readonly innerId = signal(Helpers.generateRandomString()).asReadonly();
}
